import React from "react";
import { Oval, Grid, ThreeDots } from 'react-loader-spinner';

import { useTheme } from '@mui/material/styles';

const Loader = (props) => {
    const theme = useTheme();

    return (
        props.type === "Oval" ?
            <Oval
                color={theme.palette.secondary.main}
                secondaryColor={theme.palette.secondary.light}
                strokeWidth={3}
                strokeWidthSecondary={3}
                height={50}
                width={50}
                wrapperStyle={{ justifyContent: "center" }}
            /> :
            props.type === "ThreeDots" ?
                <ThreeDots
                    color={theme.palette.secondary.main}
                    secondaryColor={theme.palette.secondary.light}
                    height={20}
                    width={80}
                    wrapperStyle={{ justifyContent: "center" }}
                /> :
                <Grid
                    color={theme.palette.secondary.main}
                    secondaryColor={theme.palette.secondary.light}
                    height={100}
                    width={100}
                    wrapperStyle={{ justifyContent: "center" }}
                />
    );
};

export default Loader;
